import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LAST_UPDATED = 'June 12, 2026';
const CONTACT_EMAIL = 'legal@signvoice.example';

export default function Terms() {
  return (
    <div className="legal-page" data-testid="terms-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back" data-testid="legal-back-link">
          <ArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </Link>
        <p className="legal-eyebrow">SignVoice · Legal</p>
        <h1 className="legal-h1">Terms of Service</h1>
        <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

        <div className="legal-body">
          <p className="legal-placeholder">
            Legal content pending review. The full terms will appear here once approved by
            counsel. Until then, here is the short version:
          </p>

          <h2>1. Service description</h2>
          <p>
            SignVoice provides an in-browser tool that translates American Sign Language hand
            gestures into spoken voice, and a Talent Connect surface for QR-based candidate
            pre-qualification. Both are offered as-is, on a best-effort basis.
          </p>

          <h2>2. Acceptable use</h2>
          <p>
            You agree not to use SignVoice or Talent Connect to harass, deceive, or discriminate
            against any person, nor to attempt to extract proprietary detection logic, weights,
            or thresholds for redistribution.
          </p>

          <h2>3. Accuracy disclaimer</h2>
          <p>
            Gesture detection is heuristic and may produce false positives or false negatives.
            SignVoice must NOT be relied on for emergency, medical, legal, or safety-critical
            communication.
          </p>

          <h2>4. Termination</h2>
          <p>
            We may suspend access if these terms are abused. You can stop using the product at
            any time — there is no account to delete.
          </p>

          <h2>5. Contact</h2>
          <p>
            Questions? Write to{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
